var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { SegmentBar } from './segment-bar';
import { SiteHeaderLogo } from '../entities/site-header-logo';
var cls = classNames('onboarding-layout');
export var OnboardingLayoutDefaultProps = {
  currentStep: 0,
  totalSteps: 0
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: calc(100vh - 140px);\n    position: relative;\n    background-color: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: calc(100vh - 140px);\n    position: relative;\n    background-color: ", ";\n  "])), theme.COLOR('app-chrome'))
});
var LogoStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    max-width: 200px;\n    padding: ", ";\n    z-index: 10;\n  "], ["\n    position: absolute;\n    top: 0;\n    left: 0;\n    max-width: 200px;\n    padding: ", ";\n    z-index: 10;\n  "])), theme.UNIT(4))
});
var ProgressBarStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: 100%;\n    z-index: 10;\n  "], ["\n    width: 100%;\n    z-index: 10;\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    width: 100%;\n    height: 100%;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: ", ";\n    padding: ", " ", ";\n    box-sizing: border-box;\n  "], ["\n    display: flex;\n    width: 100%;\n    height: 100%;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: ", ";\n    padding: ", " ", ";\n    box-sizing: border-box;\n  "])), theme.UNIT(6), theme.UNIT(10), theme.UNIT(4))
});
// -------- Components -------->
var My = {
  NAME: 'OnboardingLayout',
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Logo: styled(SiteHeaderLogo)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), LogoStyles),
  ProgressBar: styled(SegmentBar)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ProgressBarStyles),
  Body: styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles)
};
export var OnboardingLayout = function (props) {
  var componentProps = useComponentProps(My.NAME, OnboardingLayoutDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    currentStep = componentProps.currentStep,
    totalSteps = componentProps.totalSteps;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.ProgressBar, {
    maxValue: totalSteps,
    height: 8,
    value: currentStep + 1,
    tick: {
      width: 0
    },
    colors: {
      background: 'app-chrome',
      fill: 'primary'
    }
  }), React.createElement(My.Logo, {
    sizeVariant: "default"
  }), React.createElement(My.Body, null, children));
};
OnboardingLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;